/**
 * @fileoverview GET handler for the "/companies/:company_id/custom_roles/custom_role_management_data" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdCustomRolesCustomRoleManagementData } from "./constants";
import type { CompaniesCompanyIdCustomRolesCustomRoleManagementDataResult } from "./types";

export const getCompaniesCompanyIdCustomRolesCustomRoleManagementData = reactQueryFetcherAdapter(
  companiesCompanyIdCustomRolesCustomRoleManagementData,
  (
    signal: AbortSignal,
    companyId: string
  ): Promise<CompaniesCompanyIdCustomRolesCustomRoleManagementDataResult> => {
    return fetch(`/companies/${companyId}/custom_roles/custom_role_management_data`, "GET", {}, { signal });
  }
);
